import {useSelector, useDispatch} from 'react-redux';
import {RootState} from '../../../../../store/redux';
import {myStoreFiltersData, myStoreMultiSelectData} from '../../contants';
import {addFilters} from '../../../../../store/redux/myStore';

const MyStoreFiltersAdvertisement = () => {
  const dispatch = useDispatch();
  const state = useSelector((state: RootState) => state.myStore);


  return (
    <div className="flex gap-2 overflow-x-auto">
      {Object.keys(state.status_list)
        .filter(
          //@ts-ignore
          item => state.status_list[item] === true,
        )
        .map(item => (
          <div className="flex items-center border-[1px] text-sm text-farm-shop-600 rounded-full bg-farm-shop-100 w-fit py-2 px-2 whitespace-nowrap">
            <span>
              {myStoreMultiSelectData?.find(elem => elem.value === item)?.title}
            </span>
            <i
              className="icon-nameClose-remove mr-3 text-lg"
              onClick={() =>
                dispatch(
                  addFilters({
                    sorting: state.sorting,
                    status_list: {
                      pending:
                        item === 'pending'
                          ? !state.status_list[item]
                          : state.status_list.pending,
                      rejected:
                        item === 'rejected'
                          ? !state.status_list[item]
                          : state.status_list.rejected,
                      expired:
                        item === 'expired'
                          ? !state.status_list[item]
                          : state.status_list.expired,
                      promoted:
                        item === 'promoted'
                          ? !state.status_list[item]
                          : state.status_list.promoted,
                    },
                  }),
                )
              }
            />
          </div>
        ))}
      {state.sorting && (
        <div className="flex items-center border-[1px] text-sm text-farm-shop-600 rounded-full bg-farm-shop-100 w-fit py-2 px-2 whitespace-nowrap">
          <span>
            {
              myStoreFiltersData.find(item => item.value === state.sorting)
                ?.title
            }
          </span>
          <i
            className="icon-nameClose-remove mr-3 text-lg"
            onClick={() => {
              dispatch(
                addFilters({
                  sorting: '',
                  status_list: {
                    pending: state.status_list.pending,
                    rejected: state.status_list.rejected,
                    expired: state.status_list.expired,
                    promoted: state.status_list.promoted,
                  },
                }),
              );
            }}
          />
        </div>
      )}
    </div>
  );
};

export default MyStoreFiltersAdvertisement;
